import React from 'react';
//import { initialStateFx } from './WagmlState';

const WagmlContext = React.createContext({});

export default WagmlContext;